import React, { forwardRef } from 'react'

import { IconProps } from './types'

const ShieldCross = forwardRef<SVGSVGElement, IconProps>(
  ({ color, size, stroke, ...props }, ref) => (
    <svg
      ref={ref}
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill={color || 'none'}
      stroke={stroke || 'currentColor'}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M5.25 3L8 2L13.5 4V7.5C13.5 8.71002 13.2763 9.69635 12.9192 10.5M2 2L14 14M3.5 3.63636L2.5 4V7.5C2.5 13.5 8 14 8 14C8 14 10.3178 13.7893 11.9441 12" />
    </svg>
  ),
)
ShieldCross.displayName = 'ShieldCross'

export default ShieldCross
